import aborted from 'assets/icons/aborted.svg';
import add from 'assets/icons/add.svg';
import check from 'assets/icons/check.svg';
import error from 'assets/icons/error.svg';
import events from 'assets/icons/events.svg';
import execute from 'assets/icons/execute.svg';
import scann from 'assets/icons/scann.svg';
import share from 'assets/icons/share.svg';
import skipped from 'assets/icons/skipped.svg';
import success from 'assets/icons/success.svg';
import waiting from 'assets/icons/waiting.svg';
import workflow from 'assets/icons/workflow.svg';

const icons = {
  aborted,
  add,
  check,
  error,
  events,
  execute,
  scann,
  share,
  skipped,
  success,
  waiting,
  workflow
}

export default icons;
